import React from 'react';
import { IIncident } from '../../interfaces';
import IncidentWrapper from './IncidentWrapper';

interface IProps {
  event: IIncident;
  children: any;
}

// XXX a tiny wrapper to translate tha Calendar Component event prop to incident and pass it to
// the actual IncidentWrapper.
export default ({ event, children }: IProps) => {
  return <IncidentWrapper incident={event}>{children}</IncidentWrapper>;
};
